import { inject } from "aurelia";
import { BindingMode, bindable } from 'aurelia';
import { IAuthService } from '@interfaces/auth-service/auth-service-interface';
import { ICreateProjectService } from '@components/create-project-dialog/services/create-project-service';
import { FullScreenSpinnerDialog } from "@components/full-screen-spinner-dialog/full-screen-spinner-dialog";
import { nhost } from "@lib/nhost";
import { IZeusClient, ZeusClient } from "@services/graphql-service/zeus-client";
import { IDialogService } from "@aurelia/dialog";
import { toastifySuccess } from "@helpers/toastify";

interface IMediaProps {
  id: string;
  url: string;
}

@inject(IZeusClient, IAuthService, ICreateProjectService, IDialogService)
export class MediaComponent {
  @bindable({ mode: BindingMode.twoWay }) selectedImage: string;

  private selectedImageId: string;
  private userMedia: IMediaProps[] = [];
  private selectedFiles: Blob[] | File = [];

  constructor(
    private zeusClient: ZeusClient,
    private auth: IAuthService,
    private service: ICreateProjectService,
    private dialogService: IDialogService
  ) { }

  async attached() {
    await this.getMedia();
  }

  private async getMedia(): Promise<void> {
    this.userMedia = []

    const medias = await this.service.getMedia();

    for (const media of medias) {
      const imageUrl = await this.getImageUrl(media.fileId);

      this.userMedia.push({
        id: media.id,
        url: imageUrl
      });
    }
  }

  private async getImageUrl(fileId: string): Promise<string> {
    if (!fileId) return;

    return `https://uhgcmhbgmvuhtnaryxwr.storage.sa-east-1.nhost.run/v1/files/${fileId}`
  }

  private async filesChanged(event: Event) {

    if (!event) return;

    if (this.selectedFiles) {

      const spinnerDialog = await this.dialogService.open({
        component: () => FullScreenSpinnerDialog,
        model: {},
        lock: true,
        startingZIndex: 100,
      });

      const fileResult = await nhost.storage.upload({
        file: this.selectedFiles[0],
        bucketId: 'public',
      })

      await this.zeusClient.chain('mutation')({
        insert_userMedia_one: [
          {
            object: {
              fileId: fileResult.fileMetadata.id,
            },
          },
          {
            id: true,
          },
        ]
      })
      spinnerDialog.dialog.ok()

      toastifySuccess({ message: 'Sua imagem foi salva em "Meus Documentos"' })

      await this.getMedia()
    }
  }

  private selectMedia(id: string) {
    this.selectedImage = this.userMedia.find(i => i.id === id).url;
    this.selectedImageId = id;
  }
}